import React from 'react';
import PropTypes from 'prop-types';
import { BlockContentShape } from 'entities/block/shape';
import {
  BUTTON,
  IMAGE,
  TEXT,
  VIDEO,
  CUSTOM_COMPONENT,
  EMOJI,
  HERO,
  IMAGE_WITH_TEXT,
} from 'lib/block/block';
import ButtonSettings from './ButtonSettings';
import ImageSettings from './ImageSettings';
import TextSettings from './TextSettings';
import VideoSettings from './VideoSettings';
import CustomComponentSettings from './CustomComponentSettings';
import EmojiSettings from './EmojiSettings';
import HeroSettings from './HeroSettings';
import ImageWithTextSettings from './ImageWithTextSettings';

export function ContentSettings({
  blockProperties,
  blockPropertiesWithVariations,
  handleUpdate,
}) {
  const { primitiveBlock, primitiveType, blockType } = blockProperties;
  const { primitiveBlock: primitiveBlockWithVariations } =
    blockPropertiesWithVariations ?? {};

  return (
    <>
      {primitiveType === BUTTON && (
        <ButtonSettings
          content={primitiveBlock}
          contentWithVariations={primitiveBlockWithVariations}
          blockType={blockType}
          onChange={handleUpdate}
        />
      )}

      {primitiveType === IMAGE && (
        <ImageSettings
          content={primitiveBlock}
          contentWithVariations={primitiveBlockWithVariations}
          blockType={blockType}
          onChange={handleUpdate}
        />
      )}

      {/* EMOJI is a primitive but works like a text inside, 
        so we need to do this check */}
      {blockType === EMOJI && (
        <EmojiSettings content={primitiveBlock} onChange={handleUpdate} />
      )}

      {blockType !== EMOJI && primitiveType === TEXT && (
        <TextSettings
          content={primitiveBlock}
          contentWithVariations={primitiveBlockWithVariations}
          blockType={blockType}
          onChange={handleUpdate}
        />
      )}

      {primitiveType === VIDEO && (
        <VideoSettings content={primitiveBlock} onChange={handleUpdate} />
      )}

      {primitiveType === CUSTOM_COMPONENT && (
        <CustomComponentSettings
          content={primitiveBlock}
          onChange={handleUpdate}
        />
      )}

      {blockType === HERO && (
        <HeroSettings
          content={primitiveBlock}
          contentWithVariations={primitiveBlockWithVariations}
          onChange={handleUpdate}
        />
      )}

      {blockType === IMAGE_WITH_TEXT && (
        <ImageWithTextSettings
          content={primitiveBlock}
          contentWithVariations={primitiveBlockWithVariations}
          onChange={handleUpdate}
        />
      )}
    </>
  );
}

ContentSettings.propTypes = {
  blockProperties: PropTypes.shape({
    primitiveBlock: BlockContentShape,
    primitiveType: PropTypes.string,
    blockType: PropTypes.string,
  }),
  blockPropertiesWithVariations: BlockContentShape,
  handleUpdate: PropTypes.func,
};

export default ContentSettings;
